import { Cancel01Icon } from '@hugeicons/core-free-icons';
import HeaderButton from '@molecules/HeaderButton';
import { HomeScreenHeader } from '@molecules/home-screen-header/HomeScreenHeader';
import { defaultBack } from '@utils/navigation';
import { headerOptionsCreator } from '@utils/screenOptions';
import { Stack, router } from 'expo-router';
import React, { useCallback } from 'react';

export default function Layout() {
  const handleSuggestClose = useCallback(() => {
    router.navigate('/events');
  }, []);

  return (
    <Stack screenOptions={headerOptionsCreator()}>
      <Stack.Screen
        name="index"
        options={{
          ...headerOptionsCreator(),
          header: () => <HomeScreenHeader />,
        }}
      />
      <Stack.Screen
        name="schedule"
        options={headerOptionsCreator(
          <HeaderButton onPress={defaultBack('/events')} />,
        )}
      />
      <Stack.Screen
        name="suggest"
        options={headerOptionsCreator(
          <HeaderButton onPress={handleSuggestClose} icon={Cancel01Icon} />,
        )}
      />
    </Stack>
  );
}
